// extracted by mini-css-extract-plugin
module.exports = {"cartSidebar":"styles_cartSidebar__W0N4Q","cartFormSidebar":"styles_cartFormSidebar__LeWpT","cartSidebarTotal":"styles_cartSidebarTotal__cBXH9"};